import { CreateVendor } from '@atlassian/mpac-partners';

import type { RoutesConfigData } from '../../common';

export default (): RoutesConfigData[] => [
  {
    path: '/manage/vendor/create',
    component: CreateVendor,
    isPermitted: true, // You can add permission logic here if needed
    exact: true,
  },
];
